const $input        = $(".anytime-consultation-image");
const $preview      = $(".preview-image");
const $fileName     = $(".file-name");
const $error        = $(".anytime-consultation-image-error-message");
const $removeButton = $(".remove-button");
const allowedExts   = ["jpg", "jpeg", "png", "gif"];
const initialImage  = $input.data("value");

if (initialImage) {
  $preview.attr("src", initialImage).removeClass("hidden");
  $removeButton.removeClass("hidden");
}

$input.on("dragenter dragover drop", (e) => {
  e.preventDefault();
  e.stopPropagation();
});

$input.on("change", (e) => {
  $error.addClass("hidden");
  const file = e.target.files[0];
  if (!file) return;

  const ext = file.name.split(".").pop().toLowerCase();
  if ($.inArray(ext, allowedExts) === -1) {
    $input.val("");
    $preview.addClass("hidden").attr("src", "");
    $removeButton.addClass("hidden");
    $error.html(`${ext}形式のファイルはアップロードできません。<br>アップロードできるファイルタイプは .jpg .png .gif です。`).removeClass("hidden");
    return;
  }

  $fileName.text(file.name).addClass("hidden");

  $preview.off("load error").one("load", () => {
    $fileName.addClass("hidden");
    $preview.removeClass("hidden");
  }).one("error", () => {
    $fileName.removeClass("hidden");
    $preview.addClass("hidden").attr("src", "");
  });

  const reader = new FileReader();
  reader.onload = (e) => {
    $preview.attr("src", e.target.result).removeClass("hidden");
    $removeButton.removeClass("hidden");
  };
  reader.readAsDataURL(file);
});

$removeButton.on("click", () => {
  $input.val("");
  $("#cache_image").remove();
  $preview.addClass("hidden").attr("src", "");
  $fileName.addClass("hidden").text("");
  $removeButton.addClass("hidden");
  $error.addClass("hidden");
});

let spinner = $(".spinner");
spinner.hide();
$(".common-btn-main-action").on("click", function () {
  spinner.show();
});
